const API_ENDPOINTS = {
    // Auth endpoints
    auth: {
      login: `/api/auth/login`,
      register: `/api/auth/register`,
      getUserInfo: `/api/auth/user/info`,
      updateUserInfo: `/api/auth/user/update-info`,
      updateRole: `/api/auth/user/role`,
      logout: `/api/auth/logout`,
      // New user state endpoints
      setActive: `/api/auth/user/set-active`,
      setAvailable: `/api/auth/user/set-available`,
      setUnavailable: `/api/auth/user/set-unavailable`,
      updateDeviceInfo: `/api/auth/user/update-device-info`,
      getActiveStatus: `/api/auth/user/active-status`
    },
  
    // Call endpoints
    call: {
      getToken: `/api/call/token`,
      findMatch: (role) => `/api/call/find-match/${role}`,
      rateListener: `/api/call/rate-listener`,
      activeCall: `/api/call/active-call`,
      endCall: `/api/call/end-call`,
      validateState: `/api/call/validate-state`,
      health: `/api/call/health`
    },
  
    // User endpoints
    user: {
      profile: `/api/user/profile`,
      preferences: `/api/user/preferences`,
      ratings: `/api/user/ratings`,
      statistics: `/api/user/statistics`
    },
  
    // System endpoints
    system: {
      health: `/api/system/health`,
      metrics: `/api/system/metrics`,
      config: `/api/system/config`
    },
  
    // Helper functions
    buildUrl: (endpoint, params = {}) => {
      const url = new URL(endpoint, process.env.REACT_APP_API_URL);
      Object.keys(params).forEach(key => {
        url.searchParams.append(key, params[key]);
      });
      return url.toString();
    },
  
    addQueryParams: (endpoint, params = {}) => {
      const queryString = Object.keys(params)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
      return queryString ? `${endpoint}?${queryString}` : endpoint;
    }
  };
  
  // Request headers
  export const DEFAULT_HEADERS = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };
  
  // API error codes
  export const API_ERROR_CODES = {
    AUTH: {
      INVALID_TOKEN: 'INVALID_TOKEN',
      TOKEN_EXPIRED: 'TOKEN_EXPIRED',
      USER_NOT_FOUND: 'USER_NOT_FOUND',
      INVALID_CREDENTIALS: 'INVALID_CREDENTIALS'
    },
    CALL: {
      MATCH_NOT_FOUND: 'MATCH_NOT_FOUND',
      INVALID_STATE: 'INVALID_STATE',
      CONNECTION_ERROR: 'CONNECTION_ERROR'
    },
    GENERAL: {
      NETWORK_ERROR: 'NETWORK_ERROR',
      SERVER_ERROR: 'SERVER_ERROR',
      RATE_LIMIT: 'RATE_LIMIT'
    }
  };
  
  // API response handlers
  export const handleApiResponse = async (response) => {
    if (!response.ok) {
      const error = await response.json();
      throw {
        status: response.status,
        code: error.code,
        message: error.message
      };
    }
    return response.json();
  };
  
  // API error handlers
  export const handleApiError = (error) => {
    if (!error.response) {
      return {
        code: API_ERROR_CODES.GENERAL.NETWORK_ERROR,
        message: 'Network error. Please check your connection.'
      };
    }
  
    switch (error.response.status) {
      case 401:
        return {
          code: API_ERROR_CODES.AUTH.INVALID_TOKEN,
          message: 'Authentication failed. Please login again.'
        };
      case 429:
        return {
          code: API_ERROR_CODES.GENERAL.RATE_LIMIT,
          message: 'Too many requests. Please try again later.'
        };
      default:
        return {
          code: API_ERROR_CODES.GENERAL.SERVER_ERROR,
          message: 'An unexpected error occurred. Please try again.'
        };
    }
  };
  
  export { API_ENDPOINTS };
  export default  API_ENDPOINTS;